import React from "react";
import styles from "../css/Navbar.module.css";
import { Link } from "react-router-dom";
function LoginComp(props) {
  return (
    <div className={styles.userbox}>
      <Link className={styles.signupbtn} to="/signup">
        sign Up
      </Link>
      <Link className={styles.signinbtn} to="/login">
        Log In
      </Link>
    </div>
  );
}

export default LoginComp;
